module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/chicken-5008f189905106540654a92fa2eea21d.svg";